<template>
  <div class="h-screen w-full bg-primary-950">
    <!-- HERO VIDEO -->
  </div>
</template>
